import React from "react";
import { formatNumber, formatWithCommas } from "../../Utils/Toast";
import { isNumber } from "lodash";
import { useFavMatchOddsLogic } from "../useLogic/useFavMatchOddsLogic";
import RenderOddsVelkie from "./MatchDetail/RenderOddsVelkie";

const MyFavSelection = (props) => {
  const {
    object,
    totalMatched,
    ms,
    backOdds,
    layOdds,
    betSlipObject,
    showBetDialog,
    user,
    setShowBetDialog,
    setBetSlipObject,
    setToastObject,
    defaultStakeLimit,
    profileData,
    setLimit,
    position,
    oldBack,
    oldLay,
    active,
    handleActive,
    addToFavioute,
  } = props;
  let typeGame = "betFaire";
  const { runner, handelChange, localLimit, checkArrays } =
    useFavMatchOddsLogic({
      object,
      betSlipObject,
      showBetDialog,
      user,
      setShowBetDialog,
      setBetSlipObject,
      setToastObject,
      defaultStakeLimit,
      profileData,
      setLimit,
      position,
      totalMatched,
    });

  return (
    <div data-v-df39b01c>
      <div className="pb-1">
        <div
          onClick={() =>
            handleActive(object?.eventId, object?.marketId, "Odds")
          }
          className="relative py-1.5 pr-9 pl-2 text-sm text-primary bg-primary rounded-lg cursor-pointer transition-all duration-300 rounded-t-lg rounded-b-none"
        >
          <div className="flex justify-start items-center text-base text-market-name font-normal">
            <div className="-ml-2.5 pt-px mb-3px">
              <div
                data-v-117db823
                className="w-8 h-6 flex justify-center items-center"
                style={{
                  "--b64d5fc0": "0.4363636363636363",
                  "--3cad14f0": "-0.9375rem",
                }}
              >
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    addToFavioute(
                      object?.eventId,
                      "Match Odds",
                      object?.marketId,
                      object?.eventType,
                      object?.market
                    );
                  }}
                  data-v-117db823
                  className="fave animate bg-star-sprit-black-webp"
                />
              </div>
            </div>
            <div>
              <span className="pr-2">{object?.market}</span>
              <span className="pr-1 text-10 text-market-slideTab-tip">
                Matched
              </span>
              <span className="text-10 font-bold text-market-slideTab-tip">
                {formatNumber(totalMatched)}
              </span>
              <span
                className={`icon-arrow-down-sencodary absolute right-4 top-3 text-12 text-market-name transition-transform origin-center duration-300 transform ${
                  active.includes(object?.marketId) ? "rotate-180" : ""
                } `}
              />
            </div>
          </div>
        </div>{" "}
        {active.includes(object?.marketId) && (
          <div className="pt-2 bg-white rounded-bl-lg rounded-br-lg">
            <div className="mt-3px mb-1 flex justify-between items-center">
              <div className="w-9/12" />
              <div className="w-4/12 grid gap-0.5 grid-cols-2">
                <div className="min-w-min text-10 text-global-font-on-light text-center">
                  Back
                </div>
                <div className="min-w-min text-10 text-global-font-on-light text-center">
                  Lay
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="space-y-px">
                {" "}
                {runner?.map((item, index) => {
                  const odds_back = backOdds?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  const odds_lay = layOdds?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  const old_back = oldBack?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  const old_lay = oldLay?.filter(
                    (todd) => todd.ri === item.SelectionId
                  );
                  let disabelBack =
                    "lockBackBets" in item ? item?.lockBackBets : false;
                  let disabelLay =
                    "lockLayBets" in item ? item?.lockLayBets : false;
                  let disableFull = checkArrays(
                    odds_back?.slice(0, 1),
                    odds_lay?.slice(0, 1),
                    localLimit
                  );
                  let showPosition =
                    (isNumber(item?.position) &&
                      position?.length > 0 &&
                      Math.abs(item?.position) > 0) ||
                    (Math.abs(item?.newPosition) >= 0 &&
                      showBetDialog &&
                      betSlipObject?.playType == typeGame &&
                      object?.marketId == betSlipObject?.object?.newMarketId);

                  return (
                    <div>
                      <div className="flex justify-between bg-black-100">
                        <h2 className="px-2 w-9/12 flex flex-col justify-center text-13 break-all">
                          {item?.RunnerName || item?.runnerName}
                          {showPosition && (
                            <div
                              className="text-10 leading-normal flex"
                              data-testid="forecast"
                            >
                              {" "}
                              {isNumber(item?.position) &&
                                position?.length > 0 &&
                                Math.abs(item?.position) > 0 && (
                                  <span
                                    className={`flex items-center ${
                                      item?.position > 0
                                        ? "text-success"
                                        : "text-error"
                                    } `}
                                  >
                                    {isNumber(item?.position) &&
                                    Math.abs(item?.position) > 0
                                      ? item?.position > 0
                                        ? Math?.abs(item?.position).toFixed(2)
                                        : `(${Math.abs(item?.position).toFixed(
                                            2
                                          )})`
                                      : ""}
                                  </span>
                                )}
                              {Math.abs(item?.newPosition) >= 0 &&
                                showBetDialog &&
                                betSlipObject?.playType == typeGame &&
                                object?.marketId ==
                                  betSlipObject?.object?.newMarketId && (
                                  <span
                                    className={`flex items-center ${
                                      item?.newPosition > 0
                                        ? "text-success"
                                        : "text-error"
                                    } `}
                                  >
                                    <div className="icon-arrow-left rotate-180 flex text-6 mx-0.5" />{" "}
                                    {item?.newPosition > 0
                                      ? Math.abs(item?.newPosition).toFixed(2)
                                      : `(${Math.abs(item?.newPosition).toFixed(
                                          2
                                        )})`}
                                  </span>
                                )}
                            </div>
                          )}
                        </h2>
                        <RenderOddsVelkie
                          component={"betfair"}
                          index={index}
                          item={item}
                          disabelBack={disabelBack}
                          oldBack={old_back}
                          oldLay={old_lay}
                          disableFull={disableFull}
                          disabelLay={
                            object?.market == "Win" ? true : disabelLay
                          }
                          isInPlay={
                            ["Win", "Winner"].includes(object?.market)
                              ? true
                              : object?.status == "in_play"
                              ? true
                              : false
                          }
                          handelChange={handelChange}
                          odds_lay={odds_lay}
                          odds_back={odds_back}
                          limit={localLimit}
                          ms={ms}
                          betType={betSlipObject?.betType}
                          active={
                            showBetDialog &&
                            object?.marketId == betSlipObject?.newMarketId &&
                            item?.SelectionId ==
                              betSlipObject?.object?.SelectionId &&
                            typeGame == betSlipObject?.playType
                          }
                        />
                      </div>
                    </div>
                  );
                })}{" "}
                {ms != 1 && (
                  <div data-v-d884c596>
                    <div
                      data-v-d884c596
                      className="absolute right-0 top-0 flex justify-center items-center h-full bg-black-700 opacity-80 text-11 text-white rounded-md w-31%"
                    >
                      Suspend
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="pt-1 flex justify-between items-center">
              <div className="inline-flex justify-center items-center rounded bg-secondary text-global-font-on-dark px-3px py-1.5">
                <i className="pl-3px pr-0.5 icon-graph" />
                <span className="px-3px text-11"> Market Depth </span>
              </div>
              <div
                className="flex items-center text-black-600"
                data-testid="betLimit"
              >
                <i className="px-1 mt-0.5 text-14 icon-min-max" />
                <span className="px-0.5 text-11">min/max</span>
                <span className="px-1 text-11 font-bold">
                  {" "}
                  {formatWithCommas(localLimit?.minAmount)}/
                  {formatWithCommas(localLimit?.maxAmount)}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyFavSelection;
